export enum RouteNames {
  LOGIN = 'LOGIN',
  REGISTER = 'REGISTER',
  FORGOT_PASSWORD = 'FORGOT_PASSWORD',
  DASHBOARD = 'DASHBOARD',
  CHANGE_NAW = 'CHANGE_NAW',
  RESET_PASSWORD = 'RESET_PASSWORD',
}
